import { render } from "./ViewCompany.vue?vue&type=template&id=91a65206&scoped=true"
import script from "./ViewCompany.vue?vue&type=script&lang=js"
export * from "./ViewCompany.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css"
import "./ViewCompany.vue?vue&type=style&index=1&id=91a65206&scoped=true&lang=css"

import exportComponent from "/var/www/html/lynkto-vlan-ticket-admin-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91a65206"]])

export default __exports__